import React from 'react'
import { prop } from 'ramda'
import { SearchField } from 'storfox-form-fields'

import * as API from '~/constants/api'

const getOptionLabel = item => {
  if (item) {
    return prop('locationId', item)
  }

  return ''
}

const getOptionValue = item => {
  if (item) {
    const id = prop('id', item)
    const locationId = prop('locationId', item)

    return { id, locationId }
  }

  return null
}

function LocationSearchField (props) {
  return (
    <SearchField
      name="location"
      label="Location"
      api={API.LOCATION_LIST}
      getOptionValue={getOptionValue}
      getOptionLabel={getOptionLabel}
      {...props}
    />
  )
}

export default LocationSearchField
